const dom = () => {
  const findSiblingByClassName = (element, classname) => {
    let sibling = element.parentElement.firstElementChild;
    while (sibling) {
      if (sibling !== element && sibling.classList.contains(classname)) {
        return sibling;
      }
      sibling = sibling.nextElementSibling;
    }

    return null;
  };

  const classNameToSelector = (className) => `.${className}`;

  const getByClassName = (className, insideElement) => {
    const parentElement = (insideElement instanceof HTMLElement) ? insideElement : document;
    return Array.from(parentElement.getElementsByClassName(className));
  };

  const getFirstByClassName = (className, insideElement) => {
    const elements = getByClassName(className, insideElement);
    return elements.length > 0 ? elements[0] : null;
  };

  return {
    findSiblingByClassName,
    classNameToSelector,
    getByClassName,
    getFirstByClassName,
  };
};

export default dom();
